export default {
  id: 'connect-customer-followup',
  isAutoLoad: false,
  store: {
    get: {
      selected: [
        'id',
        'po', 'partID', 'partSN', 'reminderDate',
        'orderPhaseID', 'orderPhasePersonInChargeEmployeeID', 'dateInPhase', 'priorityID', 'lastInfo',
        'exchAgreementSigned', 'unitShipped', 'coreReceived', 'repairCostsApproved', 'unitReceivedCustomer',

        'rfq3.id as rfq3ID',
        'rfq3.price as price', 'rfq3.currencyID as currencyID',
        'rfq3.conditionID as conditionID', 'rfq3.quoteDate', 'rfq3.supplyDate', 'rfq3.tagInfoCompanyID',
        'rfq3.tagDate', 'rfq3.traceabilityCompanyID', 'rfq3.remarks', 'rfq3.exchangeCoreValue',
        'rfq3.exchangeCoreValueCurrencyID', 'rfq3.exchangeConditionID',
        'rfq3.exchangeCoreReceived', 'rfq3.coreDueDate', 'rfq3.stockID', 'rfq3.qty as qty',

        'rfq3.rfq.id as rfqID',
        'rfq3.rfq.rfqid as rfqid', 'rfq3.rfq.rfqTypeID as rfqTypeID',
        'rfq3.rfq.requestedDate as requestedDate',
        'rfq3.rfq.customerCompanyID as customerCompanyID',
        'rfq3.rfq.customerContactID as customerContactID'
      ],
      url: 'CustomerPOFollowUps/GetAllDynamic'
    },
    create: {
      url: 'CustomerPOFollowUps/Create'
    },
    patch: {
      // eslint-disable-next-line
      url: 'CustomerPOFollowUps/Patch/${data.id}'
    },
    delete: {
      // eslint-disable-next-line
      url: 'CustomerPOFollowUps/Delete/${data.id}'
    }
  },
  autoSave: {
    // eslint-disable-next-line
    url: 'CustomerPOFollowUps/Patch/${data.id}'
  },
  header: {
    isVisible: false
  },
  content: {
    isScroll: false
  },
  controls: {
    isVisible: false
  }
}
